import { Host, h } from '@stencil/core';
export class AibaSelfieAnalysisFailedScreen {
  constructor() {
    this.getData = undefined;
    this.handlers = undefined;
    this.data = undefined;
  }
  async componentWillLoad() {
    if (this.getData) {
      const mainData = await this.getData();
      this.data = mainData === null || mainData === void 0 ? void 0 : mainData.data;
    }
    this.handlers && this.handlers.handleSelfieAnalysisFailedScreenOnLoad && (await this.handlers.handleSelfieAnalysisFailedScreenOnLoad());
    if (this.handlers && this.handlers.getUpdatedErrorMessageData) {
      const { data } = await this.handlers.getUpdatedErrorMessageData(this.data);
      if (data)
        this.data = data;
    }
  }
  async componentDidLoad() {
    this.handlers && this.handlers.handleSelfieAnalysisFailedScreenDidLoad && (await this.handlers.handleSelfieAnalysisFailedScreenDidLoad());
  }
  async handleRetryCta(e) {
    this.handlers && this.handlers.handleRetryCta && (await this.handlers.handleRetryCta(e));
  }
  render() {
    return (h(Host, null, h("div", { class: "selfie-analysis-failed-screen-wrapper" }, this.data.map((element) => {
      if (element.name === 'aiba-image') {
        return h("img", { src: element.data.src, alt: element.data.altText });
      }
      if (element.name === 'aiba-label') {
        return h("aiba-label", Object.assign({}, element.data));
      }
      if (element.name === 'aiba-button') {
        return (h("div", { class: "retry-block" }, h("aiba-button", Object.assign({}, element.data, { handleClick: e => this.handleRetryCta(e) }))));
      }
    }))));
  }
  static get is() { return "aiba-selfie-analysis-failed-screen"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-selfie-analysis-failed-screen.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-selfie-analysis-failed-screen.css"]
    };
  }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {}
    };
  }
}
//# sourceMappingURL=aiba-selfie-analysis-failed-screen.js.map
